import { memo, useMemo } from "react";
import Big from "big.js";
import type { BiddingInfoSubItem } from "../../../types";
import { ListingCategoryConst } from "../../../constants";

interface BiddingItemMaintenanceSubItemRowProps {
  subItem: BiddingInfoSubItem;
}

export const BiddingItemMaintenanceSubItemRow = memo(
  ({ subItem }: BiddingItemMaintenanceSubItemRowProps) => {
    // 小計の計算を big.js で実行
    const subtotal = useMemo(() => {
      try {
        const c1 = new Big(subItem.capacity1 || 0);
        const q1 = new Big(subItem.quantity1 || 0);
        const c2 = new Big(subItem.capacity2 || 0);
        const q2 = new Big(subItem.quantity2 || 0);

        // (c1 * q1) + (c2 * q2)
        return c1.times(q1).plus(c2.times(q2)).toNumber();
      } catch (e) {
        return 0;
      }
    }, [
      subItem.capacity1,
      subItem.quantity1,
      subItem.capacity2,
      subItem.quantity2,
    ]);

    return (
      <div className="flex items-center pl-10 pr-4 py-2 bg-slate-50">
        <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-6 gap-y-2 items-center">
          <div className="col-start-1 col-span-5 flex items-center gap-6">
            <span className="text-slate-400">└─</span>
            <div>
              <p className="text-sm text-slate-500">容量/本数</p>
              {subItem.capacity1 && subItem.quantity1 ? (
                <p className="font-semibold text-slate-700">
                  ① {subItem.capacity1}kg × {subItem.quantity1}本
                </p>
              ) : null}

              {subItem.capacity2 && subItem.quantity2 ? (
                <p className="font-semibold text-slate-700">
                  ② {subItem.capacity2}kg × {subItem.quantity2}本
                </p>
              ) : null}
            </div>
            <div>
              <p className="text-sm text-slate-500">小計</p>
              <p className="font-semibold text-slate-700">{subtotal} kg</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">出品区分</p>
              <p
                className={`font-semibold px-2 py-1 inline-block rounded-full text-xs 
              ${
                subItem.listingCategory === ListingCategoryConst.BIDDING
                  ? "bg-blue-100 text-blue-800"
                  : subItem.listingCategory === ListingCategoryConst.SALE
                    ? "bg-green-100 text-green-800"
                    : "bg-purple-100 text-purple-800"
              }`}
              >
                {subItem.listingCategory === ListingCategoryConst.BIDDING
                  ? "入札"
                  : subItem.listingCategory === ListingCategoryConst.SALE
                    ? "入札会"
                    : "相対"}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  },
);
